import { render } from "./EnderecosCancelamento.vue?vue&type=template&id=597f2dbd&scoped=true"
import script from "./EnderecosCancelamento.vue?vue&type=script&lang=js"
export * from "./EnderecosCancelamento.vue?vue&type=script&lang=js"

import "./EnderecosCancelamento.vue?vue&type=style&index=0&id=597f2dbd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597f2dbd"]])

export default __exports__